import { configureStore } from "@reduxjs/toolkit";
import userDataSlice from "./slices/userDataSlice";
import patientsSlice from "./slices/patientsSlice";
import loaderSlice from "./slices/loaderSlice";
import workingPatternSlice from "./slices/workingPatternSlice";
import clientLeavesSlice from "./slices/clientLeaves";
import overtimeSlice from "./slices/overtimeSlice";

const reducer = {
  userData: userDataSlice,
  patients: patientsSlice,
  loader: loaderSlice,
  workingPattern: workingPatternSlice,
  clientLeaves: clientLeavesSlice,
  overtime: overtimeSlice,
};
export default configureStore({
  reducer,
});
